import template from "./deposit_reports.html";
import controller from "./deposit_reports.controller";
import "./deposit_reports.scss";

let branchManagementDepositReportsComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementDepositReportsComponent; 



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/deposit_reports/deposit_reports.component.js